module.exports = __webpack_public_path__ + "img/apple-core.cc14fb11.svg";